import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import { Level } from 'src/replicant/buruburu/level';
import StateObserver from 'src/StateObserver';

export async function levelUpSequence() {
  const {
    user: { level },
  } = StateObserver.getState();

  const levelDiff = level.current - level.lastLevelReward;

  if (!levelDiff) return;

  await openPopupPromise('popupLevelUPReward', {
    level: level.current + 1,
    reward: Level.ruleset.levelUpReward(
      level.current - levelDiff,
      level.current,
    ),
  });

  // Claim rewards.
  await StateObserver.invoke.claimLevelRewards();
}
